import styled from"@emotion/styled";import{css}from"@emotion/react";import{AntdSelect}from"@wp/src/components/common";export const ChecklistItemIconFrame=styled.div`
  display: flex;
  padding: 18px;
  align-items: center;

  border-radius: 12px;
  background: ${props=>props.theme.colors.neutral100};
`;export const SettingsContainer=styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Ensure all items have equal width */
  justify-items: stretch;
  border: 1px solid ${props=>props.theme.colors.neutral200};
  border-radius: 8px;
  gap: 0;
`;export const SettingsItemContainer=styled.div`
  padding: 8px;
  border-right: 1px solid ${props=>props.theme.colors.neutral200};
  border-bottom: 1px solid ${props=>props.theme.colors.neutral200};
  background: ${props=>props.theme.colors.white};
`;export const SettingSelect=styled(AntdSelect)`
  ${props=>props.compact?"":css`
          border: none !important;

          > div.ant-select-selector {
            &,
            &:hover,
            &:focus {
              border: none !important;
              padding: 0 !important;
            }

            .ant-select-selection-item {
              font-size: 18px;
              font-style: normal;
              font-weight: 500;
              line-height: 24px;
              color: ${props.theme.colors.neutral600};
            }
          }

          .ant-select-arrow {
            > span {
              font-size: 16px;
              font-weight: 500;
              color: ${props.theme.colors.neutral600};
            }
          }
        `}
`;